import { Edit, ListButton, useForm } from "@refinedev/antd";
import { Form, Input, InputNumber, Select, Space, Tag } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { CompassOutlined, MailOutlined, SettingOutlined } from "@ant-design/icons";
import React from "react";

import { IEntmVessels } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const EntmVesselsEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IEntmVessels>({ redirect: "list" });

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        title: "eNTM Vessel",
        subTitle: "edit eNTM vessel",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
        ghost: true,
        extra: (
          <React.Fragment>
            <Space>
              <ListButton resource="entm-vessels">eNTM Vessels</ListButton>
            </Space>
          </React.Fragment>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Vessel Information"
            subtitle="Basic vessel identification"
            icon={<CompassOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter vessel name" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="IMO Number"
                name="imoNumber"
                rules={[{ required: true, message: "Please enter IMO number" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Shipco"
                name="shipco"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="UKHO Licence"
                name="ukhoLicence"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Vessel Identifier"
                name="vesselIdentifier"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Hold Status"
                name="holdStatus"
              >
                <Select
                  options={[
                    { label: "On Hold", value: "on hold" },
                    { label: "Not On Hold", value: "not on hold" },
                  ]}
                />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <FormSection
            title="Communication"
            subtitle="Contact information"
            icon={<MailOutlined />}
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: false },
                  { type: "email", message: "Please enter a valid email address" },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Alternate Email"
                name="alternateEmail"
                rules={[
                  { required: false },
                  { type: "email", message: "Please enter a valid email address" },
                ]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <FormSection
            title="Transmission Settings"
            subtitle="Size limits for data transfer"
            icon={<SettingOutlined />}
            variant="subtle"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Max Email Size (bytes)"
                name="maxEmailSizeKb"
                rules={[{ required: false }]}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
              <Form.Item
                label="Max Transmission Size (MB)"
                name="maxTransmissionSizeMb"
                rules={[{ required: false }]}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Edit>
  );
};
